// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"31d6cfe0","344":"3b352c6d","630":"81635cbd","673":"7456a515"}[chunkId] + ".chunk.css";
};